import { Fragment } from 'react'

export type AiChatSource = { id: string; title: string; url: string }
type Source = AiChatSource
export function validSources(sources: Array<Source>): Array<Source> {
  return sources.filter((source) => {
    try {
      const url = new URL(source.url)

      return (
        ['http:', 'https:'].includes(url.protocol) &&
        !url.username &&
        !url.password
      )
    } catch {
      return false
    }
  })
}
export function AiChatCitedContent({
  content,
  sources,
}: {
  content: string
  sources: Array<Source>
}) {
  const safe = validSources(sources)

  return content.split(/(\[\d+\])/).map((part, index) => {
    const source = safe.find((candidate) => `[${candidate.id}]` === part)

    return source ? (
      <a
        key={index}
        href={source.url}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
        title={source.title}
      >
        {part}
      </a>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  })
}
export function AiChatSources({ sources }: { sources: Array<Source> }) {
  const safe = validSources(sources)
  if (!safe.length) return null

  return (
    <ul className="mt-2 space-y-1 text-xs">
      {safe.map((source) => (
        <li key={source.id}>
          <a
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            [{source.id}] {source.title}
          </a>
        </li>
      ))}
    </ul>
  )
}

export function aiChatSources(
  calls: Array<{ sources?: Array<Source> }>,
): Array<Source> {
  const sources = calls.flatMap((call) => call.sources ?? [])

  return Array.from(
    new Map(
      validSources(sources).map((source) => [source.id, source]),
    ).values(),
  )
}
